<template>
  <div class="table-wrapper" :style="{ maxHeight: heightList + 'px' }">
    <table class="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th class="sticky-header sticky-column">MK</th>
          <th
            class="sticky-header"
            v-for="golongan in golonganStore"
            :key="golongan.id"
          >
            {{ golongan.nama }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="mk in masaKerjaRange" :key="mk" class="table-row">
          <td class="sticky-column">
            <strong>{{ mk }}</strong>
          </td>
          <td v-for="golongan in golonganStore" :key="golongan.id">
            {{ lihatGapokDetail(mk, golongan) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.table-wrapper {
  /* overflow: auto; */
  /* max-height: 300px;  */
  overflow-y: auto; /* Enable vertical scrolling */
  overflow-x: auto;
}

.table {
  min-width: 800px;
  border-collapse: collapse;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  z-index: 10;
}

.sticky-column {
  position: sticky;
  left: 0;
  background-color: #f8f9fa;
  z-index: 5;
}

.table th,
.table td {
  padding: 8px;
  text-align: left;
}
</style>

<script>
import { useCommonStore } from "@/stores/utility/common-store2";
import { computed } from "vue";
import * as commonFunction from "@/utils/common-function.js";
import _ from "lodash";
export default {
  props: {
    gajiPokokId: {
      type: Number,
      required: true,
    },
    heightList: {
      type: Number,
      default: null,
    },
    gajiPokokSkemaDetailStore: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const commonStore = useCommonStore();

    // Defining masaKerjaRange and golonganStore locally
    const masaKerjaRange = computed(() => {
      return Array.from({ length: 34 }, (v, k) => k); // 0 to 33
    });

    const golonganStore = computed(() => commonStore.golonganStore);

    // Defining lihatGapokDetail function locally
    const lihatGapokDetail = (mk, golongan) => {
      // const result = _.find(commonStore.gajiPokokSkemaDetailStore, (item) => {
      const result = _.find(props.gajiPokokSkemaDetailStore, (item) => {
        return (
          _.get(item, "masa_kerja") === mk &&
          _.get(item, "golongan_id") === golongan.id
          // && _.get(item, "gaji_pokok_skema_id") === props.gajiPokokId
        );
      });
      return result ? commonFunction.formatNumberWithDots(result.jml) : "";
    };

    return {
      masaKerjaRange,
      golonganStore,
      lihatGapokDetail,
    };
  },
};
</script>
